import { egresadosApiCall } from "../../../../axios/apiClient";

const controller = ``;

export default {
    forgotPasswordEgresado: async (data) => {
        let response = { success: true };
        const method = `forgot-password`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    resetPasswordEgresado: async (data) => {
        let response = { success: true };
        const method = `reset-password`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    confirmAccountEgresado: async (data) => {
        let response = { success: true };
        const method = `confirm-account`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    onResendTokenByConfirmAccount: async (data) => {
        let response = { success: true };
        const method = `resend-token-confirm-account`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    validateTokenEgresado: async (data) => {
        let response = { success: true };
        const method = `validate-token`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
}